export class Atribucion {
  public Nombre: string;
  public id: number;
  constructor() {}
  cargar(data) {
    this.Nombre = data.puesto;
    this.id = Number(data.id);
  }
}
